import * as React from 'react';
import classNames from 'classnames';
import * as styles from './styles.css';

interface ILayoutProps {
  stretch?: boolean;
  children?: React.ReactNode;
}

export function Layout({ children, stretch }: ILayoutProps) {
  return (
    <div className={classNames({ [styles['stretch']]: stretch, [styles['container']]: !stretch })}>{children}</div>
  );
}
